module.exports = __webpack_public_path__ + "instagram.png?9b32444eba9318b264ad637582fdc378";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagram.png
// module id = 337
// module chunks = 0